import { render, staticRenderFns } from "./ServiceCloudRow.vue?vue&type=template&id=10f2659f&scoped=true&"
import script from "./ServiceCloudRow.vue?vue&type=script&lang=js&"
export * from "./ServiceCloudRow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCloudRow.vue?vue&type=style&index=0&id=10f2659f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f2659f",
  null
  
)

export default component.exports